<template>
  <div class="stray">
    <img src="../../assets/imgs/404.png">
    <div>
      <router-link to="/login">
        <button>跳到登录页</button>
      </router-link>
      <router-link to="/">
        <button>回到首页</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "publicity"
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>